<template>
  {{ Orders.Orders }}
  <table class="top-24 col-12" v-if="TrueOrders.length > 0">
    <thead>
    <tr>
      <th class="width-10">Номер заявки</th>
      <th class="width-10">Дата рейса</th>
      <th class="width-10">Номер машины</th>
      <th class="width-10">Вес (кг)</th>
      <th class="width-10">ФИО водителя</th>
      <th>Действие</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="order in SortedOrders">
      <td>{{ order.OrderID }}</td>
      <td>{{ format_date(order.OrderDate) }}</td>
      <td>{{ order.OrderCar }}</td>
      <td>{{ order.OrderWeight }}</td>
      <td>{{ order.OrderDriver }}</td>
      <td>
        <router-link
          v-if="!order.OrderStatus"
          :to="getEditOrderLink(order)"
          class="btn-secondary"
          style="margin-right: 8px;">
          <span class="icon-Edit"></span>Редактировать
        </router-link>
<!--        <router-link-->
<!--          v-if="canCopyOrder"-->
<!--          :to="getCopyOrderLink(order)"-->
<!--          class="btn-primary">-->
<!--          <span class="icon-Plus"></span>Копировать-->
<!--        </router-link>-->
        <router-link
            :to="getCopyOrderLink(order)"
            class="btn-primary">
          <span class="icon-Plus"></span>Копировать
        </router-link>
      </td>
    </tr>
    </tbody>
  </table>
  <div class="top-24 col-12" v-else-if="TrueOrders.length < 1">
    За период не было выполненных рейсов с указанным весом
  </div>
</template>

<script>
import 'vue-good-table-next/dist/vue-good-table-next.css'
import { VueGoodTable } from 'vue-good-table-next';
import moment from 'moment'

export default {
  components: { VueGoodTable },
  data() {
    return {
      datefilter: [this.today_date(), this.tomorrow_date()],
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    canCopyOrder() {
      const allowedINNs = ['5257084971', '5837067698', '5260462711', '5257016604'];
      const userINN = String(this.currentUser.company_inn);
      console.log('OrdersList - User INN:', userINN, 'Type:', typeof this.currentUser.company_inn);
      console.log('OrdersList - Can copy:', allowedINNs.includes(userINN));
      return allowedINNs.includes(userINN);
    },
    Orders() {
      return this.$store.state.polygon_orders.Orders
    },
    TrueOrders() {
      if (!this.Orders || !Array.isArray(this.Orders)) {
        return [];
      }
      // return this.Orders
      return this.Orders.filter(order => {
        return order.OrderWeight &&
            order.OrderWeight !== 'NaN' &&
            order.OrderWeight !== null &&
            order.OrderWeight !== undefined &&
            order.OrderWeight !== '' &&
            order.OrderWeight !== 0;
      });
    },
    SortedOrders() {
      const sorted = this.TrueOrders.sort((a, b) => new Date(b.OrderDate) - new Date(a.OrderDate));

      // Дополняем данные из localStorage
      const savedOrders = JSON.parse(localStorage.getItem('orderDetails') || '{}');

      return sorted.map(order => {
        const savedData = savedOrders[order.OrderID];
        if (savedData) {
          // Если есть сохраненные данные, дополняем заявку
          return {
            ...order,
            ContractID: savedData.ContractID || order.ContractID || '',
            WasteTypes: savedData.WasteTypes || order.WasteTypes || [],
            WasteProcents: savedData.WasteProcents || order.WasteProcents || []
          };
        }
        return order;
      });
    },
  },
  methods: {
    format_date(value, time='NaN'){
      if (value) {
        if (time != 'NaN') {
          return moment(String(value)).format('DD.MM.YYYY')
        } else {
          return moment(String(value)).format('DD.MM.YYYY HH:mm')
        }
      }
    },
    today_date(){
      const today = new Date();
      return moment(String(today)).format('YYYY-MM-DD')
    },
    tomorrow_date(){
      const today = new Date();
      const date = today.getFullYear()+'-0'+(today.getMonth()+1)+'-'+(today.getDate()+1);
      return date
    },
    Change(number) {
      number = Math.trunc(number)
      return number.toString().replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ')
    },
    hasValidWasteTypes(order) {
      // Проверяем, есть ли виды отходов и не являются ли они пустыми строками
      if (!order.WasteTypes || !Array.isArray(order.WasteTypes)) {
        return false;
      }

      // Проверяем, что нет пустых строк или строк состоящих только из пробелов
      const hasEmptyWaste = order.WasteTypes.some(waste => {
        return !waste || waste.trim() === '' || waste.trim() === ' ';
      });

      return !hasEmptyWaste;
    },
    getCopyOrderLink(order) {
      const contractID = order.ContractID || order.OrderContract || order.Contract || '';

      const query = {
        previous_OrderCar: order.OrderCar || '',
        previous_OrderDriver: order.OrderDriver || ''
      };

      // Добавляем договор если он есть
      if (contractID) {
        query.previous_OrderContract = contractID;

        // Добавляем виды отходов ТОЛЬКО если есть договор И они валидны
        if (this.hasValidWasteTypes(order)) {
          query.previous_WasteTypes = order.WasteTypes;
          query.previous_WasteProcents = (order.WasteProcents || []).map(p => Number(p).toFixed(3));
          console.log('Копирование с договором и видами отходов:', contractID, order.WasteTypes);
        } else {
          console.log('Копирование с договором, но БЕЗ видов отходов (пустые строки):', contractID);
        }
      } else {
        console.log('Копирование БЕЗ договора и БЕЗ видов отходов');
      }

      return {
        name: 'new_order',
        query: query
      };
    },
    getEditOrderLink(order) {
      const contractID = order.ContractID || order.OrderContract || order.Contract || '';

      const query = {
        previous_OrderID: order.OrderID || '',
        previous_OrderDate: order.OrderDate ? order.OrderDate.split('T')[0] : '',
        previous_OrderCar: order.OrderCar || '',
        previous_OrderDriver: order.OrderDriver || ''
      };

      // Добавляем договор если он есть
      if (contractID) {
        query.previous_OrderContract = contractID;

        // Добавляем виды отходов ТОЛЬКО если есть договор И они валидны
        if (this.hasValidWasteTypes(order)) {
          query.previous_WasteTypes = order.WasteTypes;
          query.previous_WasteProcents = (order.WasteProcents || []).map(p => Number(p).toFixed(3));
          console.log('Редактирование с договором и видами отходов:', contractID, order.WasteTypes);
        } else {
          console.log('Редактирование с договором, но БЕЗ видов отходов (пустые строки):', contractID);
        }
      } else {
        console.log('Редактирование БЕЗ договора и БЕЗ видов отходов');
      }

      return {
        name: 'edit_order',
        query: query
      };
    },
  },
  created() {
    this.$store.dispatch("fetchPolygonOrders", { inn: this.currentUser.company_inn, start_date: "2024-01-01", end_date: this.today_date() });
  },
};
</script>